import { addDays } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'

const FALLBACK_RESERVATION_AVAILABILITY_START_DAYS_OFFSET = 0
const FALLBACK_RESERVATION_AVAILABILITY_WINDOW_IN_DAYS = 62

const getReservationAvailabilityWindow = (
  {
    reservationAvailabilityStartDaysOffset = FALLBACK_RESERVATION_AVAILABILITY_START_DAYS_OFFSET,
    reservationAvailabilityWindowInDays = FALLBACK_RESERVATION_AVAILABILITY_WINDOW_IN_DAYS,
    timeZone,
  }: {
    reservationAvailabilityStartDaysOffset?: number
    reservationAvailabilityWindowInDays?: number
    timeZone: string
  },
  now = new Date()
) => {
  const rawStart = zonedTimeToUtc(now.toISOString().split('T')[0], timeZone)
  const start = addDays(rawStart, reservationAvailabilityStartDaysOffset)
  const end = addDays(start, reservationAvailabilityWindowInDays)

  return { end, start }
}

export { getReservationAvailabilityWindow }
